export const CONTACT_CODE = [
	{
		name: "WhatsApp",
		code: "WA",
		link: "https://wa.me/message/TGXCPRDSMYNRK1",
		image: "./static/img/whatsappct.png",
	},
	// {
	// 	name: "Zalo",
	// 	code: "KR",
	// 	link: "https://zalo.me/84866942974",
	// 	image: "./static/img/zaloct.png",
	// },
];

export const STYLE_CODE = [
	{
		name: "Choose chat app",
		code: "0",
		link: "🇰🇷",
		image: "./static/img/chat.png",
	},
	// {
	// 	name: "Zalo",
	// 	code: "1",
	// 	link: "🇰🇷",
	// 	image: "./static/img/zaloct.png",
	// },
];

export const STYLE_CODE_RES = [
	{
		name: "Chat app",
		code: "0",
		link: "🇰🇷",
		image: "./static/img/chat.png",
	},
	// {
	// 	name: "Zalo",
	// 	code: "1",
	// 	link: "🇰🇷",
	// 	image: "./static/img/zaloct.png",
	// },
];
